import { Geolocation } from "@capacitor/geolocation";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { accuracyValidThreshold } from "../../config";
import { useLocationStore } from "./store";

export function DeviceLocationProvider() {
  const setLocation = useLocationStore((state) => state.setLocation);
  const lastLocation = useRef<{
    latitude: number;
    longitude: number;
    accuracy: number;
  }>(null);
  const { t } = useTranslation("location");

  useEffect(() => {
    const watchId = Geolocation.watchPosition(
      { enableHighAccuracy: true },
      (pos, error) => {
        if (error) {
          console.error("Error getting geolocation:", error);
          setLocation({ state: "error", error, updatedAt: Date.now() });
        } else if (!pos) {
          console.warn("No geolocation resolved");
          setLocation({
            state: "error",
            error: new Error(t("error.unresolved")),
            updatedAt: Date.now(),
          });
        } else {
          const latitude = pos.coords.latitude;
          const longitude = pos.coords.longitude;
          const accuracy = pos.coords.accuracy;

          if (
            !lastLocation.current ||
            lastLocation.current.latitude !== latitude ||
            lastLocation.current.longitude !== longitude ||
            lastLocation.current.accuracy !== accuracy
          ) {
            if (accuracy <= accuracyValidThreshold) {
              setLocation({
                state: "available",
                koordinaten: { latitude, longitude },
                accuracy,
                updatedAt: Date.now(),
              });
            } else {
              setLocation({
                state: "error",
                error: new Error(
                  t("error.inaccurate", { accuracy: Math.round(accuracy) }),
                ),
                updatedAt: Date.now(),
              });
            }

            lastLocation.current = { latitude, longitude, accuracy };
          }
        }
      },
    );

    return () => {
      watchId.then((id) => Geolocation.clearWatch({ id }));
    };
  }, [setLocation, t]);

  return null;
}
